"use client";
import { jsx as s } from "react/jsx-runtime";
import { twMerge as p } from "tailwind-merge";
function i({ content: e, fontFamily: o = "polysans", className: r }) {
  return /* @__PURE__ */ s(
    "div",
    {
      className: p(`
        prose prose-gray max-w-none
        prose-headings:font-normal prose-headings:text-current
        prose-h1:text-5xl prose-h1:leading-tight prose-h1:my-0 prose-h1:font-semibold
        prose-h2:text-4xl prose-h2:leading-tight prose-h2:my-0 prose-h2:font-semibold
        prose-h3:text-3xl prose-h3:leading-snug prose-h3:my-0 prose-h3:font-semibold
        prose-h4:text-2xl prose-h4:leading-snug prose-h4:my-0 prose-h4:font-semibold
        prose-h5:text-xl prose-h5:leading-snug prose-h5:my-0 prose-h5:font-medium
        prose-h6:text-lg prose-h6:leading-snug prose-h6:my-0 prose-h6:font-medium
        prose-p:text-base prose-p:my-0 prose-p:leading-relaxed prose-p:text-gray-700
        prose-a:text-blue-600 prose-a:no-underline hover:prose-a:text-blue-800 hover:prose-a:underline prose-a:font-medium
        prose-strong:font-semibold prose-strong:text-gray-900
        prose-em:italic prose-em:text-gray-700
        prose-code:bg-gray-100 prose-code:text-gray-800 prose-code:px-1 prose-code:py-0.5 prose-code:rounded prose-code:text-sm prose-code:font-mono prose-code:font-normal
        prose-pre:bg-gray-900 prose-pre:text-gray-100 prose-pre:p-4 prose-pre:rounded-lg prose-pre:overflow-x-auto prose-pre:my-4
        prose-blockquote:border-l-4 prose-blockquote:border-gray-300 prose-blockquote:pl-4 prose-blockquote:italic prose-blockquote:text-gray-600 prose-blockquote:my-4
        prose-ul:list-disc prose-ul:pl-6 prose-ul:my-4 prose-ul:space-y-2
        prose-ol:list-decimal prose-ol:pl-6 prose-ol:my-4 prose-ol:space-y-2
        prose-li:text-base prose-li:leading-relaxed prose-li:text-gray-700
        prose-img:rounded-lg prose-img:my-4
    `, o === "inter" ? "font-inter" : "font-polysans", r),
      dangerouslySetInnerHTML: { __html: e ?? "" }
    }
  );
}
export {
  i as RichText
};
